/* eslint-disable */
import { IAccount, IPipeline, IPipelinePkg, IRecordProject, IScript, IScriptPages, ITask, ITaskPages, ITaskRecord, ITaskRecordCom, ITaskStat, ITaskStatus } from '@/interfaces';
import { TaskState } from './state';
import { AppNotification, MainState } from '../main/state'
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { dispatchGetAccounts, dispatchGetPipelinePkgs, dispatchGetPipelines, dispatchGetScripts, dispatchGetSimpleScripts, dispatchGetTasks, dispatchGetTaskStats } from './actions';
import { store } from '..';
import { readAccountList, readPipelineList, readTaskList } from './getters';
import { dispatchGetProjectScenes } from '../project/actions';

export const mutations = {
    setTaskRecord(state: TaskState, payload: ITaskRecord) {
        state.taskRecord = payload;
    },
    addNotification(state: MainState, payload: AppNotification) {
        state.notifications.push(payload);
    },
    setTasks(state: TaskState, payload: ITaskPages) {
        state.taskList = payload;
    },
    updateTask(state: TaskState,payload:{project:number,page:number,size:number,task_name:string}) {
        // dispatchGetTasks(store, {project: payload.project,page:payload.page,size:payload.size,task_name:payload.task_name})
        readTaskList(store)
    },
    deleteTask(state: TaskState, payload: ITaskPages) {
        // state.taskList = payload;
        readTaskList(store)
    },
    setTask(state: TaskState, payload: ITaskPages) {
        // const taskList = state.taskList.results.filter((task: ITask) =>  task.task_id !== payload.task_id);
        // taskList.push(payload);
        // state.taskList = payload;
        readTaskList(store)
    },
    setTaskStatus(state: TaskState, payload: ITaskStatus) {
        state.TaskStatus = payload;
    },
    setTaskStats(state: TaskState, payload: ITaskStat[]) {
        state.TaskStats = payload;
    },
    setPerformanceVersions(state: TaskState, payload: any) {
        state.PerformanceVersions = payload;
    },
    setRecordProject(state: TaskState, payload: IRecordProject) {
        state.recordProject = payload;
    },

    setAccounts(state: TaskState, payload: IAccount[]) {
        state.accountList = payload;
    },
    deleteAccount(state: TaskState, payload: number) {
        state.accountList = state.accountList.filter((account: IAccount) => account.account_id !== payload);
    },
    setAccount(state: TaskState, payload: IAccount) {
        // const accountList = state.accountList.filter((account: IAccount) =>  account.account_id !== payload.account_id);
        // accountList.push(payload);
        // state.accountList = accountList;
    },
    updateAccount(state: TaskState, project: any) {
        dispatchGetAccounts(store, {project: project})
        readAccountList(store)
    },
    setTaskRecords(state: TaskState, payload: ITaskRecord[]) {
        state.taskRecords = payload;
    },
    setSimpleTaskRecords(state: TaskState, payload: ITaskRecordCom) {
        state.taskSimpleRecords = payload;
    },
    setScripts(state: TaskState, payload: IScriptPages) {
        state.scriptList = payload;
    },
    setSimpleScripts(state: TaskState, payload: IScript[]) {
        state.simpleScriptList = payload;
    },
    setScript(state: TaskState,payload:{ project: number,page:number,size:number,script_name:string}) {
        // dispatchGetScripts(store, {project: payload.project,page:payload.page,size:payload.size,script_name:payload.script_name})
        // dispatchGetSimpleScripts(store, {project: payload.project})
        // dispatchGetProjectScenes(store, {project: payload.project})
    },
    updateScript(state: TaskState, payload:{project: number,page:number,size:number,script_name:string}) {
        dispatchGetScripts(store, {project: payload.project,page:payload.page,size:payload.size,script_name:payload.script_name})
        dispatchGetSimpleScripts(store, {project: payload.project})
    },
    deleteScript(state: TaskState, payload:{project: number,page:number,size:number,script_id:number,script_name:string}) {
        dispatchGetScripts(store, {project: payload.project,page:payload.page,size:payload.size,script_name:payload.script_name})
        state.simpleScriptList = state.simpleScriptList.filter((script: IScript) => script.script_id !== payload.script_id);
    },
    setPipelines(state: TaskState, payload: IPipeline[]) {
        state.pipelineList = payload;
    },
    setPipeline(state: TaskState, project: number) {
        dispatchGetPipelines(store, {project: project})
    },
    updatePipeline(state: TaskState, project: any) {
        dispatchGetPipelines(store, {project: project})
        readPipelineList(store)
    },
    deletePipeline(state: TaskState, payload: string) {
        state.pipelineList = state.pipelineList.filter((pipeline: IPipeline) => pipeline.pipeline_key !== payload);
    },
    setPipelinePkgs(state: TaskState, payload: IPipelinePkg[]) {
        state.pipelinePkgList = payload;
    },
    setDownloadPkg(state: TaskState, payload:any) {
        state.downloadPkg = payload;
    },
    setPipelineCheck(state: TaskState, payload:any) {
        state.pipe_line = payload;
    },
    setPipelinePkg(state: TaskState, project: number) {
        // const PipelinePkgs = state.pipelinePkgList.filter((pkg: IPipelinePkg) =>  pkg.id !== payload.id);
        // PipelinePkgs.push(payload);
        // state.pipelinePkgList = PipelinePkgs;
        dispatchGetPipelinePkgs(store, {project: project, pipeline_id: null})
    },
    deletePipelinePkg(state: TaskState, pkg_id: number) {
        state.pipelinePkgList = state.pipelinePkgList.filter((pkg: IPipelinePkg) => pkg.id !== pkg_id);
    },
    setRunTask(state: TaskState,payload: {project: number, page:number,size:number,task_name:string}) {
        dispatchGetTaskStats(store, {project: payload.project})
        dispatchGetTasks(store, {project: payload.project,page:payload.page,size:payload.size,task_name:payload.task_name})
    },
    
};

const {commit} = getStoreAccessors<TaskState | any, State>('');

export const commitAddNotification = commit(mutations.addNotification);
// 任务
export const commitSetTasks = commit(mutations.setTasks);
export const commitSetRecordProject = commit(mutations.setRecordProject);
export const commitDeleteTask = commit(mutations.deleteTask);
export const commitSetTask = commit(mutations.setTask);
export const commitUpdateTask = commit(mutations.updateTask);
export const commitRunTask = commit(mutations.setRunTask);
export const commitSetTaskStatus = commit(mutations.setTaskStatus);
export const commitSetTaskStats = commit(mutations.setTaskStats);
export const commitSetPerformanceVersions = commit(mutations.setPerformanceVersions);
// 账号
export const commitSetAccounts = commit(mutations.setAccounts);
export const commitDeleteAccount = commit(mutations.deleteAccount);
export const commitSetAccount = commit(mutations.setAccount)
export const commitUpdateAccount = commit(mutations.updateAccount)
// 任务记录
export const commitSetTaskRecords = commit(mutations.setTaskRecords)
export const commitSetSimpleTaskRecords = commit(mutations.setSimpleTaskRecords)
export const commitSetTaskRecord = commit(mutations.setTaskRecord);
// 脚本
export const commitSetScripts = commit(mutations.setScripts);
export const commitSetSimpleScripts = commit(mutations.setSimpleScripts);
export const commitSetScript = commit(mutations.setScript);
export const commitUpdateScript = commit(mutations.updateScript);
export const commitDeleteScript = commit(mutations.deleteScript);
// 流水线
export const commitSetPipeline = commit(mutations.setPipeline)
export const commitSetPipelines = commit(mutations.setPipelines);
export const commitUpdatePipeline = commit(mutations.updatePipeline);
export const commitDeletePipeline = commit(mutations.deletePipeline);
export const commitSetPipelinePkgs = commit(mutations.setPipelinePkgs);
export const commitDownloadPkg = commit(mutations.setDownloadPkg);
export const commitSetPipelineCheck = commit(mutations.setPipelineCheck);
export const commitSetPipelinePkg = commit(mutations.setPipelinePkg);
export const commitDeletePipelinePkg = commit(mutations.deletePipelinePkg);


